import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientReferralVerification } from '../../../core/models/client-referral-verification.model';
import { FormsModule } from '@angular/forms';

import { ClientReferralTaskDateComponent } from '../client-referral-task-date/client-referral-task-date.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-client-referral-task-dates',
    templateUrl: './client-referral-task-dates.component.html',
    styleUrls: ['./client-referral-task-dates.component.scss'],
    imports: [FormsModule, ClientReferralTaskDateComponent, FaIconComponent]
})
export class ClientReferralTaskDatesComponent {
  @Input() verifications: ClientReferralVerification[];
  @Input() canAddVerifications;
  @Input() formDisabled: boolean;

  @Output() updateVerification = new EventEmitter<{ id: number; referralDate: string }>();
  @Output() removeVerification = new EventEmitter<number>();
  @Output() addVerification = new EventEmitter();

  constructor() {}


  onUpdate(verification: { id: number; referralDate: string }) {
    this.updateVerification.emit(verification);
  }

  onRemove(id: number) {
    this.removeVerification.emit(id);
  }

  onAddClick($event) {
    $event.preventDefault();
    this.addVerification.emit();
  }
}
